module.exports = __webpack_public_path__ + "img/camera.ad47d996.png";